export const SITE_CONFIG = {
  SITE_ID: 'maricopa.renovations',
  ANALYTICS: { GA4_MEASUREMENT_ID: 'G-1H2246YM0V' },
  BASE_URL: 'maricoparenovations.com',
  SITE_URL: 'https://maricoparenovations.com',
  AMPLIFY_WEBHOOK: 'https://webhooks.amplify.us-east-1.amazonaws.com/prod/webhooks?id=fe8c8438-35f9-469f-aca4-42e31d1718fe&token=ccmNvPZyK5PTEg9sPmCZM9N2ag01KcjrUVNNvaCVRE&operation=startbuild',
  SENDER_EMAIL_ENCRYPTION_KEY: 'ddc32d25f6877ce7692b7361fe9c3cfa75c8fedc8ddbfb6529a636b950fd11bf',
  STATE: 'AZ',
  BUSINESS: {
    NAME: 'Maricopa Renovations',
    LEGAL_NAME: 'Maricopa Renovations LLC',
    OWNER: 'Gary Hopkins',
    PARTNER: 'Sandy Hopkins',
    EMAIL: 'info@MaricopaRenovations.com',
    PHONE: '(520) 895-2672',
    PHONE_E164: '+15208952672',
    LICENSE: 'ROC #294216',
    STREET: '41600 W Smith Enke Rd, Building 2, Suite 110',
    CITY: 'Maricopa',
    REGION: 'AZ',
    POSTAL_CODE: '85138',
    HOURS: 'Monday–Friday, 9:00 AM–4:30 PM; weekends by appointment',
    SERVICE_AREA: 'Maricopa, Arizona',
    FACEBOOK: 'https://www.facebook.com/MaricopaRenovations'
  },
  ASSETS: {
    LOGO: 'https://aw-client-logos-and-headshots.s3.us-east-2.amazonaws.com/logos/maricopa-renovations-logo.png',
    TEAM: 'https://aw-client-logos-and-headshots.s3.us-east-2.amazonaws.com/headshots/maricopa.renovations_fd7015c206d34197a22ae469bb51ea7f.png',
    HERO_VIDEO: 'https://agentwinds-client-landings.s3.us-east-1.amazonaws.com/Man_and_woman_installing_cabinets_20260919125423.mp4',
    HERO_POSTER: '/images/maricopa-cabinets-poster.jpg'
  },
  AGENT: {
    MLS_ID: '',
    NAME: 'Gary Hopkins',
    EMAIL: 'info@MaricopaRenovations.com',
    PHONE: '(520) 895-2672',
    ZILLOW_REVIEW: '',
    GOOGLE_REVIEW: '',
    BROKERAGE_LICENSE: '',
    LICENSE: 'ROC #294216'
  },
  MLS: { NAME: '', SHORT_NAME: '', LOGO_URL: '', DISCLAIMER: '' }
};
